import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import { setSkipRestoreFrom404, getBackFrom404Path } from "../utils/RouteUtils";

function P404() {
  useEffect(() => {
    setSkipRestoreFrom404();
  }, []);

  const backPath = getBackFrom404Path();
  const isHome = backPath === "/";

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/50 px-4 sm:px-6">
      <div className="max-w-md w-full text-center">
        <div className="relative inline-block mb-6 sm:mb-8">
          <span className="text-8xl sm:text-9xl font-extrabold text-transparent bg-clip-text bg-gradient-to-br from-slate-400 to-slate-600 select-none">
            404
          </span>
        </div>
        <h1 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-2">
          Page not found
        </h1>
        <p className="text-slate-600 text-sm sm:text-base mb-8">
          The page you’re looking for doesn’t exist or has been moved.
        </p>
        <Link
          to={backPath}
          className="inline-flex items-center justify-center gap-2 px-5 py-2.5 sm:px-6 sm:py-3 rounded-lg bg-rpr-blue text-white font-medium hover:opacity-90 focus:ring-2 focus:ring-rpr-blue focus:ring-offset-2 transition"
        >
          <MdArrowBack className="w-5 h-5" />
          {isHome ? "Go Home" : "Go back"}
        </Link>
      </div>
    </div>
  );
}

export default P404;
